import STATUS_CODES from 'constants/statusCodes';
import files from 'helpers/files';
import SignUpServices from 'services/sign_up';

const hasRequiredSignupSteps = (stepsData) =>
	Array.isArray(stepsData) &&
	[0, 1, 2, 3].every((stepIndex) => {
		const stepData = stepsData[stepIndex];
		return stepData && typeof stepData === 'object' && !Array.isArray(stepData);
	});

const getPaymentMethodsFromResponse = (response) => response?.data?.data?.steps_data?.[3]?.paymentMethods;

export const getAuctionAccessSignupData = async () => {
	const response = await SignUpServices.instance.getSignUpPartialData();
	const partialSignUp = response?.data?.data;

	if (
		response?.status !== STATUS_CODES.OK ||
		!partialSignUp?.token ||
		!hasRequiredSignupSteps(partialSignUp.steps_data)
	) {
		throw new Error('Unable to load AuctionACCESS signup data');
	}

	return {
		email: partialSignUp.steps_data[0].email || '',
		stepsData: partialSignUp.steps_data,
		token: partialSignUp.token,
	};
};

export const submitAuctionAccessDocumentsRequest = async ({ token, treatments, values }) => {
	const driverLicenseFile = values.driverLicenseFile?.[0];
	const userProfileAttributes = {};

	// use null to remove the driver license file if it was previously uploaded and the user removed it
	if (!driverLicenseFile) {
		userProfileAttributes.drivers_license_file = null;
	} else if (driverLicenseFile?.size > 0) {
		// this avoids the case where user resumes the signup and we do not have the file but a url.
		userProfileAttributes.drivers_license_file = await files.toBase64(driverLicenseFile);
	}

	const body = {
		sign_up_token: token,
		user: {
			user_legal_attributes: {
				tax_identification_number: values.taxID,
			},
			user_profile_attributes: userProfileAttributes,
			partial_sign_up_attributes: {
				last_step: 2,
				fall_2024_dealer_radio_removal: treatments?.fall_2024_dealer_radio_removal,
			},
		},
	};
	const { data } = await SignUpServices.instance.confirmStepUpdate(body);
	if (!data?.token) throw new Error('Unable to submit AuctionACCESS documents');

	const paymentMethodsResponse = await SignUpServices.instance.getSignUpPartialData(data.token);

	return {
		paymentMethods: getPaymentMethodsFromResponse(paymentMethodsResponse),
		signUpEmail: data.signup_email,
		token: data.token,
	};
};

export const submitAuctionAccessReviewRequest = async ({ marketplaceDocumentIds = [] }) => {
	const { data } = await SignUpServices.instance.confirmStepUpdate({
		auction_access: { step_one_completion: true },
		user: { marketplace_document_ids: marketplaceDocumentIds },
	});

	return data;
};

export const getAuctionAccessPaymentMethods = async (token) => {
	const response = await SignUpServices.instance.getSignUpPartialData(token);
	return getPaymentMethodsFromResponse(response);
};
